import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    IndependentClaimApi,
    IndependentClaimsRequest,
    IndependentClaimsResponse,
    ConfirmClaimRequest,
    ConfirmClaimResponse,
} from '../independent-claim-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class IndependentClaimApiImpl extends GuestAwareHttpService implements IndependentClaimApi {
    async getIndependentClaims(request: IndependentClaimsRequest): Promise<IndependentClaimsResponse> {
        const res = await this.postWithGuestSupport<IndependentClaimsResponse>(
            {
                data: request,
            },
            'patent/independent_claims',
        );
        return res;
    }

    async confirmClaim(request: ConfirmClaimRequest): Promise<ConfirmClaimResponse> {
        const res = await this.postWithGuestSupport<ConfirmClaimResponse>(
            {
                data: request,
            },
            'claim/confirm',
        );
        return res;
    }
}
